export const female_gloves = [ //An array of each Female Glove's ID, Atlas file, and name. There are ??.
  {
    id: 'glove0', //Append either vb_frontarm_hand or vb_backarm_hand to find class.
    name: 'No gloves' //Show name in textbox.
  },
  {
    id: 'glove3',
    name: 'Something metal?'
  },
]